const base = {
  default: {}
};

const press = {
  default: {}
};

const wrapper = {
  products: {
    chart: base,
    co: base,
    edu: base,
    press,
    spark: base
  }
};

export default wrapper;
